module.exports = __webpack_public_path__ + "media/img/pages/companies/ehl-hospitality-business-school-ae2a0d82d44785bb50ccb605fcd3a05a.webp";